import React from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from './Dashboard'
function IFrame() {
  const { client_id, module_id, scenario_id, user_id } = useParams();
  return (<Dashboard client_id={client_id} module_id={module_id} scenario_id={scenario_id} user_id={user_id}/>);
}
export default IFrame;